// @flow
import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Select, Divider } from "antd";
import * as actions from "../../actions";
import CategoryTreeSelect from "../category-tree-select";
import { withLoading } from "../hoc";
import type { State } from "../../types/store";
import type { TagsState } from "../../reducers/tags";
import type { Entities } from "../../types/entities";
import type { SelectCategoryAction } from "../../actions/categories";
import type { SelectPropertyAction } from "../../actions/properties";

const Option = Select.Option;

type Props = {
  categories: Entities,
  selectedById: {
    [string]: Array<string>
  },
  properties: Entities,
  propSelectedById: {
    [string]: Array<string>
  },
  tags: TagsState,
  onSelectCategory: (
    key: string,
    values: Array<string>
  ) => SelectCategoryAction,
  onSelectProperty: (
    key: string,
    values: Array<string>
  ) => SelectPropertyAction,
  onSelectTags: (values: Array<string>) => SelectPropertyAction
};

let FiltersByTypology = ({
  categories,
  selectedById,
  properties,
  propSelectedById,
  tags,
  onSelectCategory,
  onSelectProperty,
  onSelectTags
}: Props) => {
  const onCategoryChange = (values: Array<string>, key: string) => {
    onSelectCategory(key, values);
  };

  const tagChange = value => {
    onSelectTags(value);
  };

  const onPropertyChange = (values: Array<string>, key: string) => {
    onSelectProperty(key, values);
  };

  return (
    <div className="filters-by-typology">
      {categories.all.map(id => {
        const { label, children, isDisabled } = categories.byId[id];
        const values = selectedById[id];
        return children && (!isDisabled || values.length > 0) ? (
          <div key={id}>
            <Divider className="filters-label">{label}</Divider>
            <CategoryTreeSelect
              placeholder="Select one or more Categories"
              treeData={children}
              selectedNodes={values}
              onSelectNode={values => onCategoryChange(values, id)}
            />
          </div>
        ) : null;
      })}
      {tags.entities.all.length > 0 &&
        (tags.hasResults || tags.selectedTags.length > 0) && (
          <div>
            <Divider className="filters-label">Tags</Divider>
            <Select
              className="search-panel-element"
              value={tags.selectedTags}
              placeholder="Select one or more tags"
              onChange={tagChange}
              mode="multiple"
              notFoundContent="Not Found"
              allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {tags.entities.all.map(_id => {
                const { id, name, disabled } = tags.entities.byId[_id];
                return (
                  <Option key={id} value={id.toString()} disabled={disabled}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </div>
        )}
      {properties.all.map(id => {
        const { label, children, disabled } = properties.byId[id];
        const values = propSelectedById[id];
        return children && (!disabled || values.length > 0) ? (
          <div key={id}>
            <Divider className="filters-label">{label}</Divider>
            <CategoryTreeSelect
              placeholder="Select one or more values"
              treeData={children}
              selectedNodes={values}
              onSelectNode={values => onPropertyChange(values, id)}
            />
          </div>
        ) : null;
      })}
    </div>
  );
};

const loadingCondition = props => props.isLoading;

FiltersByTypology = compose(withLoading(loadingCondition))(FiltersByTypology);

function mapStateToProps(state: State) {
  const {
    entities: categories,
    selectedById
  } = state.filters.byTypology.categories;
  const {
    entities: properties,
    selectedById: propSelectedById
  } = state.filters.byTypology.properties;
  const { tags } = state.filters.byTypology;
  const { isLoading } = state.filters.byTypology;
  return {
    categories,
    properties,
    selectedById,
    propSelectedById,
    tags,
    isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSelectCategory: bindActionCreators(actions.selectCategory, dispatch),
    onSelectProperty: bindActionCreators(actions.selectProperty, dispatch),
    onSelectTags: bindActionCreators(actions.setTags, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersByTypology);

FiltersByTypology.propTypes = {
  categories: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  selectedById: PropTypes.object.isRequired,
  propSelectedById: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  onSelectProperty: PropTypes.func.isRequired,
  onSelectTags: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/filtersbytypology/index.js